<template>
  <div>
    <u-loader
      v-if="editionsLoading != 0"
      text="Moment...Versionen und Editionen werden noch geladen."
    />
    <div v-else>
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <p>
        Wählen Sie eine Version und eine Edition aus und ob die Mindestlohndaten
        kopiert/ aus Datei importiert werden sollen.
      </p>
      <u-loader v-if="isLoading" />
      <div v-else>
        <v-select
          v-model="value.VersionId"
          style="z-index: 3000"
          :items="versionEditions"
          label="Version"
          :item-text="getVersionDisplay"
          item-value="id"
          @change="selectFirstEdition"
        />
        <v-select
          :key="value.VersionId"
          v-model="value.EditionId"
          style="z-index: 3000"
          :items="possibleEditions"
          label="Edition"
          item-text="editionLabel"
          item-value="editionId"
        />
        <v-select
          v-model="value.CopyMindestlohn"
          style="z-index: 3000"
          :items="copyMindestlohnOptions"
          label="Mindestlohnkonfiguration"
          item-text="label"
          item-value="id"
        />
        <template v-if="value.CopyMindestlohn == 3">
          <div class="d-block mb-4">
            Wählen sie die Datei aus von welcher die Konfigurationen import
            werden sollen.
          </div>
          <div>
            <input
              ref="importMiloSalaryFile"
              class="ml-4 mb-4"
              name="importMiloSalaryFile"
              type="file"
              @change="handleFileUpload"
            >
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { GetAllEditions } from "@/services/contract.edition.service.js";
import { GetAllContractVersions } from "@/services/contract.service.js";
import { UniaGAVConstants } from "@/assets/configuration/constants.js";

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          VersionId: -1,
          EditionId: -1,
          CopyMindestlohn: 1,
          MiloSalaryImport: null,
        };
      },
    },
    currentContractNumber: {
      type: String,
      default: "",
    },
    currentVersionNumber: {
      type: Number,
      default: 0,
    },
    currentEditionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      versionEditions: [],
      isLoading: false,
      editionsLoading: 0,
      errorObject: null,
      UniaGavConstants: UniaGAVConstants,
      copyMindestlohnOptions: [
        { id: 1, label: "Mindestlohndaten kopieren" },
        { id: 2, label: "Nur Kommentare kopieren" },
        { id: 0, label: "Nicht kopieren" },
      ],
    };
  },
  computed: {
    possibleEditions() {
      var versionIndex = this.versionEditions.findIndex((version) => {
        return version.id === this.value.VersionId;
      });

      if (versionIndex === -1) {
        return [];
      }

      return this.versionEditions[versionIndex].Editions;
    },
  },
  created() {
    let that = this;
    this.numberOfEditions = 0;
    this.loadAllVersions();
    console.log(
      this.currentContractNumber,
      this.currentVersionNumber,
      this.currentEditionId,
    );
    if (this.$IsUserInRole("ImportMiloKonfig")) {
      this.copyMindestlohnOptions = [
        { id: 1, label: "Mindestlohndaten kopieren" },
        { id: 2, label: "Nur Kommentare kopieren" },
        { id: 3, label: "Mindestlohndaten aus Datei importieren" },
        { id: 0, label: "Nicht kopieren" },
      ];
    }

    this.$eventBus.$on("editionsChanged", () => {
      that.loadAllVersions();
    });
  },
  methods: {
    getVersionDisplay(item) {
      return "Version " + item.number;
    },
    selectFirstEdition() {
      if (this.value.VersionId > 0) {
        // if the version is changed, we select the first (the latest) edition by default
        var newVersionObject = this.versionEditions.filter((version) => {
          return version.id === this.value.VersionId;
        })[0];

        if (
          newVersionObject &&
          newVersionObject.Editions &&
          newVersionObject.Editions[0]
        ) {
          this.value.EditionId = newVersionObject.Editions[0].editionId;
        }
      }
    },
    handleFileUpload() {
      const file = this.$refs.importMiloSalaryFile.files[0];

      //Get the JSON from the file
      const reader = new FileReader();

      reader.onload = () => {
        try {
          const jsonObject = JSON.parse(reader.result);
          if (jsonObject) {
            this.value.MiloSalaryImport = jsonObject;
          }
        } catch (error) {
          this.errorObject = error;
        }
      };

      reader.onerror = (error) => {
        this.errorObject = error;
      };

      reader.readAsText(file);
    },
    loadAllVersions() {
      let that = this;
      this.isLoading = true;

      GetAllContractVersions(
        this.currentContractNumber,
        (allVersions) => {
          console.log(allVersions);
          allVersions.data.map((version) => {
            if (version.number === this.currentVersionNumber) {
              this.value.VersionId = version.id;
            }
            that.versionEditions.push(version);
            that.loadAllEditions(version.number);
          });
        },
        (error) => {
          that.isLoading = false;
          that.errorObject = error;
        },
      );
    },
    loadAllEditions(versionNumber) {
      let that = this;
      this.isLoading = true;
      this.editionsLoading++;

      GetAllEditions(
        this.currentContractNumber,
        versionNumber,
        (allEditions) => {
          var versionIndex = that.versionEditions.findIndex((version) => {
            return version.number === versionNumber;
          });

          that.versionEditions[versionIndex].Editions = [];
          allEditions.map((edition) => {
            that.versionEditions[versionIndex].Editions.push({
              editionId: edition.editionId,
              currentStatus: edition.stateId,
              editionLabel: `${edition.editionId} (${that.UniaGavConstants.UniaContractEditionState[edition.stateId]} - ${edition.ownerPrincipal})`,
            });
          });

          if (
            versionNumber == that.currentVersionNumber &&
            that.versionEditions[versionIndex].Editions[0]
          ) {
            that.selectFirstEdition();
          }

          that.isLoading = false;
          that.editionsLoading--;
        },
        (error) => {
          that.errorObject = error;
          that.isLoading = false;
          that.editionsLoading--;
        },
      );
    },
  },
};
</script>

<style scoped></style>
